<template>
	<div
	 class="el-card"
	 :class="shadow ? 'is-' + shadow + '-shadow' : 'is-always-shadow'"
	 style="position:relative"
	>
		<div
		 class="el-card__header"
		 v-if="$slots.header || header"
		>
			<slot name="header">{{ header }}</slot>
		</div>
		<div
		 class="el-card__body"
		 :style="bodyStyle"
		>
			<slot></slot>
		</div>
		<div class="options">
			<el-row>
				<el-col
				 :span="8"
				 class="viewe"
				 :style="viewStyle"
				>
					<span
					 style="cursor:pointer"
					 @click="view"
					>
						<svg-icon
						 icon-class="picview"
						 style="width:2em;height:2em;"
						></svg-icon>
					</span>
				</el-col>
				<el-col
				 :span="8"
				 class="viewe"
				 :style="viewStyle"
				 style="border-left:1px solid #ececec"
				>
					<span
					 style="cursor:pointer"
					 @click="edit"
					>
						<svg-icon
						 icon-class="picedit"
						 style="width:2em;height:2em;"
						></svg-icon>
					</span>
				</el-col>
				<el-col
				 :span="8"
				 class="viewlink"
				>
					<span
					 style="cursor:pointer"
					 :style="viewStyle"
					 @click="link"
					>
						<svg-icon
						 icon-class="aboutinfo"
						 style="width:2em;height:2em;"
						></svg-icon>
					</span>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
  name: "DiCard",
  props: {
    header: {},
    bodyStyle: {},
    viewStyle: {},
    shadow: {
      type: String
    },
    data: {}
  },
  methods: {
    view() {
      this.drawer = true;
      this.$emit("view", this.data);
    },
    edit() {
      this.$emit("edit", this.data);
    },
    link() {
      this.$emit("link", this.data);
    }
  }
};
</script>
<style lang="scss" scoped>
.options {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover .options {
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: block;
}
.viewe {
  background: #f5f5f5;
}
.viewlink {
  background: #e9e9e9;
}
</style>




// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/dicard.vue